import { render, staticRenderFns } from "./CustomerCTDetail.vue?vue&type=template&id=57a31820&scoped=true"
import script from "./CustomerCTDetail.vue?vue&type=script&lang=js"
export * from "./CustomerCTDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a31820",
  null
  
)

export default component.exports